import { createContext, useContext, useState } from "react";

const LeadContext = createContext(null);

export const LeadProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefillPest, setPrefillPest] = useState(null);
  const openModal = (pest = null) => {
    setPrefillPest(pest);
    setOpen(true);
  };
  return (
    <LeadContext.Provider value={{ open, setOpen, openModal, prefillPest }}>
      {children}
    </LeadContext.Provider>
  );
};

export const useLead = () => useContext(LeadContext);
